import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { NonNullableFormBuilder, ReactiveFormsModule, Validators } from '@angular/forms';
import { MatButton } from '@angular/material/button';
import { MatDialogActions, MatDialogClose, MatDialogContent } from '@angular/material/dialog';
import { MatFormField, MatLabel } from '@angular/material/form-field';
import { MatInput } from '@angular/material/input';
import { AutofocusDirective } from '@shared/directives/autofocus.directive';
import { COMMISSION_RATE_VALIDATORS } from '@shared/forms/forms.constants';
import { SharedStore } from '@shared/store/shared.signal-store';
import { isDefined } from '@stillmandigital/common';
import { toApiReferralAgentRateValue } from 'app/settings/store/referral-agents/referral-agents.utils';

@Component({
  selector: 'app-create-referral-agent',
  templateUrl: './create-referral-agent.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  imports: [
    MatLabel,
    MatFormField,
    ReactiveFormsModule,
    MatInput,
    MatButton,
    MatDialogActions,
    MatDialogClose,
    MatDialogContent,
    AutofocusDirective,
  ],
})
export class CreateReferralAgentComponent {
  private readonly _sharedStore = inject(SharedStore);
  private readonly _fb = inject(NonNullableFormBuilder);

  public readonly createForm = this._fb.group({
    name: ['', Validators.required],
    commissionRate: [0, COMMISSION_RATE_VALIDATORS],
  });

  public create() {
    const { name, commissionRate } = this.createForm.value;
    const rate = toApiReferralAgentRateValue(commissionRate);

    if (isDefined(name) && isDefined(rate)) {
      this._sharedStore.createReferralAgent({ name, commissionRate: rate });
    }
  }
}
